import { useSeoMeta } from "@unhead/react";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useSeoMeta({
    title: "404 // SIGNAL LOST",
    description: "This location does not exist in our database.",
  });

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <main className="min-h-screen flex items-center justify-center px-4">
      <div className="pixel-border bg-card/80 p-8 md:p-12 max-w-md w-full text-center space-y-4">
        <div className="font-pixel text-6xl md:text-8xl text-neon-magenta text-glow-magenta animate-star-twinkle">
          404
        </div>
        <div className="font-pixel text-sm md:text-base text-neon-cyan text-glow-cyan tracking-widest">
          SIGNAL LOST
        </div>
        <div className="font-mono text-xs md:text-sm text-foreground/80">
          The coordinates you entered are not on file.<br />
          Please return to base.
        </div>
        <div className="font-mono text-[10px] text-muted-foreground break-all">
          PATH: {location.pathname}
        </div>
        <Link
          to="/"
          className="inline-block pixel-border-soft bg-black/80 px-5 py-2 font-pixel text-xs text-neon-amber hover:text-glow-amber tracking-widest mt-2"
        >
          &gt; RETURN TO HOME
        </Link>
      </div>
    </main>
  );
};

export default NotFound;
